// OVD: only autoplay videos that aren't already playing; force MP4 on non-Safari (HLS .m3u8 fails silently in Chrome).
(function () {
  var IS_SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  function pickPlayableSource(video) {
    if (IS_SAFARI) return;
    if (video.dataset.ovdSourceFixed === '1') return;
    var sources = video.querySelectorAll('source');
    if (!sources.length) return;
    var mp4 = null;
    sources.forEach(function (s) {
      var t = (s.type || '').toLowerCase();
      var src = (s.src || s.getAttribute('src') || '').toLowerCase();
      if (!mp4 && (t.indexOf('mp4') >= 0 || /\.mp4(\?|$)/.test(src))) mp4 = s;
    });
    if (mp4) {
      sources.forEach(function (s) { if (s !== mp4) s.parentNode && s.parentNode.removeChild(s); });
      video.dataset.ovdSourceFixed = '1';
      try { video.load(); } catch (e) {}
    }
  }

  function playMediaBannerVideos() {
    var videos = document.querySelectorAll('.media-banner-media video');
    videos.forEach(function (video) {
      video.muted = true;
      video.playsInline = true;
      video.autoplay = true;
      video.loop = true;
      pickPlayableSource(video);
      // If already playing, leave it alone — resetting kills mid-play progress.
      if (!video.paused && !video.ended && video.readyState >= 2) return;
      var p = video.play();
      if (p !== undefined) {
        p.catch(function () {
          setTimeout(function () { video.play().catch(function () {}); }, 300);
        });
      }
    });
  }

  // Throttle MutationObserver work so it doesn't fire continuously and reset videos.
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      playMediaBannerVideos();
    });
  }

  var mediaBannerObserver = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes && muts[i].addedNodes.length) { schedule(); return; }
    }
  });
  mediaBannerObserver.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', playMediaBannerVideos);
  } else {
    playMediaBannerVideos();
  }
})();
